export default "__VITE_ASSET__RyrZIdTZ__"